import { render, staticRenderFns } from "./UrunSatisFiyatPeriyotItem.vue?vue&type=template&id=4d94a65d&scoped=true"
import script from "./UrunSatisFiyatPeriyotItem.vue?vue&type=script&lang=js"
export * from "./UrunSatisFiyatPeriyotItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94a65d",
  null
  
)

export default component.exports